import { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import Button from "@weave-design/button";
import { Settings24 } from "@weave-design/icons";
import { ProcessingFailure } from "../../../processing-failure/processingFailure";
import { ProcessingPane } from "../../../processing-pane/processingPane";
import { rootElement } from "../../../shared";
import { ITypesManagerStartGenerationFailurePayload } from "../../eventBus/typesManagerEventPayloads";
import eventBus, { IApplicationEvent } from "../../eventBus/eventDispatcher";

type Props = {
    panelTypeId: string;
    isPanelModel: boolean;
    isRegenerate?: boolean;
};

export const GenerateNewPanelContent = ({ panelTypeId, isPanelModel, isRegenerate }: Props) => {
    const [generationStarted, setGenerationStarted] = useState(false);
    const [failureMessage, setFailureMessage] = useState<string>();

    useEffect(() => {
        setGenerationStarted(false);
        setFailureMessage(undefined);
    }, [panelTypeId, isPanelModel]);

    useEffect(() => {
        const onGenerationFailed = (event: IApplicationEvent<ITypesManagerStartGenerationFailurePayload>) => {
            setGenerationStarted(false);
            setFailureMessage(event.payload.message);
        };

        eventBus.addEventListener("Dextall.TypesManager.GenerationRequest.Failed", onGenerationFailed);

        return () => {
            eventBus.removeEventListener("Dextall.TypesManager.GenerationRequest.Failed", onGenerationFailed);
        };
    }, []);

    const onClick = () => {
        eventBus.dispatchEvent({
            type: "Dextall.TypesManager.SingleGeneration.Requested",
            payload: { panelTypeId, isPanelModel },
        });
        setGenerationStarted(true);
    };

    const title = isRegenerate ? "Regenerate" : "Generate";

    const buttonType = isRegenerate ? "secondary" : "primary";

    return (
        <div style={{ margin: 17 }}>
            <Button title={title} icon={<Settings24 />} onClick={onClick} type={buttonType} />
            {generationStarted &&
                ReactDOM.createPortal(
                    <ProcessingPane
                        isVisible={true}
                        message="Starting generation..."
                        title="Generating the panel..."
                    />,
                    rootElement,
                )}
            {failureMessage !== undefined &&
                ReactDOM.createPortal(
                    <ProcessingFailure
                        closeProcessingErrorDialog={() => setFailureMessage(undefined)}
                        isVisible={true}
                        title="Error"
                        message={failureMessage}
                    />,
                    rootElement,
                )}
        </div>
    );
};
